module.exports = __webpack_public_path__ + "static/img/giphy_mangolimedrop.ff9c881.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/giphy_mangolimedrop.gif
// module id = P/bQ
// module chunks = 0